import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../services';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    // This page only loads after authentication happens. Therefore, if we have `sso_logged_out` set in localStorage,
    // we need to get rid of it because we are logged in properly.
    localStorage.removeItem('sso_logged_out');
    // console.log('removed SSO logged out localStorage');

    const queryParams = this.route.snapshot.queryParams;
    const msg = queryParams['message'];
    const error = queryParams['error'];
    const success = queryParams['success'];

    if (msg) {
      if (error || success == 'false') {
        this.toast.error(msg);
      } else {
        this.toast.info(msg);
      }
    }
  }
}
